export default "__VITE_ASSET__u0pQvB3H__"